import * as React from 'react';
import styled from 'styled-components';
import { compose } from '@doltech/utils/lib/compose';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { useGrammarAuthorListingFilter } from '../hooks/useGrammarAuthorListingFilter';
import {
  GrammarAuthorBlogList,
} from '../components/GrammarAuthorBlogList';
import { useQuery } from 'react-query';
import {
  getAllBlogsOfAuthorByAuthorIdPaged,
} from '../../shared/apis/landing-grammar';
import { LoadingScreen } from '../../home-page/components/LoadingScreen';
import { PaginationPaging } from '@doltech/ui/lib/figma/Pagination/PaginationPaging/PaginationPaging';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Container = styled.div`
  ${verticalSpace(24)};

  margin: 0 auto;
  padding-bottom: 32px;

  .pagination {
    justify-content: flex-end;
  }

  .pagination-component {
    padding: 0 16px;
  }

  ${fromScreen(768)} {
    padding-bottom: 0;
    margin: 0;
  }
`;

const TitleWrapper = styled.div`
  padding: 0 16px;
  max-width: 500px;
  margin: 0 auto;

  ${fromScreen(768)} {
    ${verticalSpace(16)};
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
`;

interface SectionAuthorBlogListingNotAuthorProps {
  initData?: any;
  authorId?: string;
}

const SectionAuthorBlogListingNotAuthorContent = ({ initData, authorId }: SectionAuthorBlogListingNotAuthorProps) => {
  const { filter, filterQuery } = useGrammarAuthorListingFilter();
  const { page, setPage } = filter;
  const { data, isLoading } = useQuery<any>(
    ['getAllBlogsOfAuthorByAuthorIdPaged', filterQuery, authorId],
    () =>
      getAllBlogsOfAuthorByAuthorIdPaged({ ...filterQuery, authorId }),
    {
      refetchOnMount: true,
      keepPreviousData: false,
      initialData: initData,
    },
  );

  if (isLoading) {
    return <LoadingScreen/>;
  }

  return (
    <Container className="session-author-blog-listing">
      <TitleWrapper>
        <ResponsiveTypography.Paragraph variant="semi-bold/32-40" color="gray180">
          Bài viết
        </ResponsiveTypography.Paragraph>
      </TitleWrapper>
      <GrammarAuthorBlogList data={data?.content} />
      {Boolean(data?.totalPages) && (
        <PaginationPaging
          totalPages={data?.totalPages || 2}
          currentPageIndex={page}
          onChange={setPage}
          color="purple"
          hideOnSingle
        />
      )}
    </Container>
  );
};

export const SectionAuthorBlogListingNotAuthor = compose(SectionAuthorBlogListingNotAuthorContent);
